import { useEffect, useState } from 'react';

import styles from './styles.module.scss';
import stylesTimeline from '../Timeline/styles.module.scss';
import { WeatherCard } from './index.jsx';
import { getSensorCoordinates } from '../../utils/sensor';
import { useGetWeatherForecastQuery } from '../../store/api/weather';
import { useViewport } from '../../hooks';
import { BreakpointMobile } from '../../constants/ui';

const WeatherForecast = ({ t, location }) => {
  const [coordinates, setCoordinates] = useState(null);
  const [data, setData] = useState([]);
  const { widthViewport } = useViewport();

  const {
    data: weatherData = [],
    isSuccess: isWeatherDataSuccess,
    isFetching: isWeatherDataLoading,
  } = useGetWeatherForecastQuery(
    { lat: coordinates ? coordinates[1] : '', lon: coordinates ? coordinates[0] : '' },
    { skip: !coordinates || coordinates.length === 0, refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    if (!location || (!location.gps_point && !location.install_point)) return;

    const sensorCoordinates = getSensorCoordinates({
      gpsPoint: location.gps_point,
      installPoint: location.install_point,
    });

    setCoordinates(sensorCoordinates && sensorCoordinates.length ? sensorCoordinates : null);
  }, [location]);

  useEffect(() => {
    if (!isWeatherDataSuccess || !weatherData) return;
    setData(weatherData);
  }, [isWeatherDataSuccess, weatherData]);

  return (
    !isWeatherDataLoading &&
    isWeatherDataSuccess &&
    data.length && (
      <div className={stylesTimeline.timelineContentBlock}>
        <h2 className={stylesTimeline.timelineContentTitle}>{t('weather.title')}</h2>
        <div className={styles.weatherForecast}>
          {data.map((item, index) => {
            return (
              (widthViewport > BreakpointMobile || index < 3) && (
                <WeatherCard key={item.date} params={item} widthViewport={widthViewport} t={t} />
              )
            );
          })}
        </div>
      </div>
    )
  );
};

export default WeatherForecast;
